import PropTypes from 'prop-types';
import React, { ReactElement } from 'react';
import { getStatusIndicatorFromValues } from '../connectedForm/HeaderBlock/HeaderStatusUtils';
import { ISalesOrder } from '../../graphql/schema/p4types';
import { IStatusFlag } from '../connectedForm/HeaderBlock/HeaderBlock';
import HeaderTitle from '../connectedForm/HeaderTitle';

const SalesOrderHeader = ({
  orderNumber,
  statusFlags,
  optValue,
  values,
}: {
  orderNumber: number | string;
  statusFlags: IStatusFlag | Array<IStatusFlag>;
  optValue: ReactElement | string;
  values: ISalesOrder;
}) => {
  const statusIndicators = [];
  if (statusFlags && Array.isArray(statusFlags)) {
    for (let i = 0; i < statusFlags.length; i++) {
      statusIndicators.push(...getStatusIndicatorFromValues(statusFlags[i], values));
    }
  } else if (statusFlags) {
    statusIndicators.push(...getStatusIndicatorFromValues(statusFlags, values));
  }

  return <HeaderTitle value={orderNumber} optValue={optValue} status={statusIndicators} />;
};

SalesOrderHeader.propTypes = {
  optValue: PropTypes.string,
};

SalesOrderHeader.defaultProps = {
  optValue: null,
};

export default SalesOrderHeader;
